<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.tenants_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
				>
					<template v-slot:[`item.image`]="{ item }">
						<app-thumbnail-placeholder
							v-model="item.image"
						></app-thumbnail-placeholder>
					</template>
					<template v-slot:[`item.cover_image`]="{ item }">
						<app-thumbnail-placeholder
							v-model="item.cover_image"
						></app-thumbnail-placeholder>
					</template>
					<template v-slot:[`item.widget`]="{ item }">
						<v-btn
							color="success"
							outlined
							small
							:href="item.reservation_widget_url"
							target="_blank"
						>
							{{ $t("Widget") }}
							<v-icon right>mdi-open-in-new</v-icon>
						</v-btn>
					</template>
					<template v-slot:[`item.impersonate`]="{ item }">
						<v-btn
							color="success"
							outlined
							small
							@click="
								$inertia.post(
									$route('central.impersonate', item.id)
								)
							"
							>{{ $t("label.manage") }}
							<v-icon right>mdi-open-in-new</v-icon>
						</v-btn>
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button
							v-model="item.active"
						></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>
		<app-create-fab-button
			@click="$inertia.visit($route('central.tenants.create'))"
		></app-create-fab-button>
		<app-delete-id-dialog
			ref="deleteDialog"
			:endpoint="'central.tenants.destroy'"
			:id="item.id"
		></app-delete-id-dialog>
	</v-container>
</template>

<script>
export default {
	props: ["data"],
	data() {
		return {
			filter: {},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.tenants.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "left",
					width: 80,
				},
				{
					text: this.$t("label.logo"),
					value: "image",
					align: "start",
					sortable: false,
					width: 100,
				},
				{
					text: this.$t("label.cover_image"),
					value: "cover_image",
					align: "start",
					sortable: false,
					width: 100,
				},
				{
					text: this.$t("Name"),
					value: "name",
					sortable: false,
					searchable: false,
					width: 150,
				},
				{
					text: this.$t("label.outlets_count"),
					value: "outlets_count",
					sortable: false,
					searchable: false,
					align: "center",
					width: 200,
				},
				{
					text: this.$t("Menus Count"),
					value: "menus_count",
					sortable: false,
					searchable: false,
					align: "center",
					width: 120,
				},
				{
					text: this.$t("Users Count"),
					value: "users_count",
					sortable: false,
					searchable: false,
					align: "center",
					width: 120,
				},
				{
					text: this.$t("Sort Order"),
					value: "sort_order",
					sortable: false,
					searchable: false,
					width: 120,
					align: "center",
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					width: 150,
					align: "right",
				},
				{
					text: this.$t("Widget"),
					value: "widget",
					sortable: false,
					searchable: false,
					align: "right",
					width: 60,
				},
				{
					text: this.$t("Impersonate"),
					value: "impersonate",
					sortable: false,
					searchable: false,
					align: "right",
					width: 60,
				},
			];
		},
	},

	methods: {
		onFilter() {
			//
		},

		editItem(item) {
			this.$inertia.get(this.$route("central.tenants.edit", item.id));
		},

		viewItem(item) {
			this.$inertia.get(this.$route("central.tenants.show", item.id));
		},

		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>